import Loader from 'components/Loader';
import Paginate from 'components/Paginate';
import TableError from 'components/TableError';
import useRequest from 'hooks/useRequest';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Table, UncontrolledDropdown } from 'reactstrap';
import { SORT_VALUES_CREATED_DATE } from 'utils/constants';
import { buildURL, printDate, printSerialNumbers } from 'utils/helper';
import { SMKLinks } from 'utils/links';

const SchoolFaqs = ({ schoolId }) => {
  const [faqsList, setFaqsList] = useState([]);
  const [faqsPagination, setFaqsPagination] = useState({});

  const [getSchoolFaqsRequest, { loading: getSchoolFaqsRequestLoading }] = useRequest({
    url: '/school/admin/faq/search',
    method: 'POST',
    onSuccess: (data) => {
      setFaqsList(data?.results);
      setFaqsPagination(data?.pagination);
    },
  });

  const [updatefaqRequest, { loading: updatefaqRequestLoading }] = useRequest({
    method: 'PUT',
    onSuccess: () => {
      handleChangePage(1);
      toast.success('School Faq has been updated');
    },
  });

  const handleChangePage = (page) => {
    getSchoolFaqsRequest({
      body: {
        page: page ? page : 1,
        size: 20,
        schoolId,
        ...SORT_VALUES_CREATED_DATE,
      },
    });
  };

  const handleActive = (elem) => {
    updatefaqRequest({
      url: `/school/admin/faq/${elem?.id}`,
      body: {
        ...elem,
        active: !elem.active,
        deleted: false,
      },
    });
  };

  const handleDelete = (elem) => {
    updatefaqRequest({
      url: `/school/admin/faq/${elem?.id}`,
      body: {
        ...elem,
        deleted: !elem.deleted,
        active: false,
      },
    });
  };

  useEffect(() => {
    getSchoolFaqsRequest({
      body: {
        page: 1,
        size: 20,
        schoolId,
        ...SORT_VALUES_CREATED_DATE,
      },
    });
  }, []);

  return (
    <div>
      <Loader isActive={getSchoolFaqsRequestLoading || updatefaqRequestLoading} />
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4>School FAQ's</h4>

        <Link
          className="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2"
          to={buildURL(SMKLinks.ADD_SCHOOL_FAQ, {
            schoolId,
          })}>
          <i className="mdi mdi-plus me-1" />
          Add School FAQ
        </Link>
      </div>

      <div>
        <div className="table-responsive" style={{ minHeight: 300 }}>
          <Table className="project-list-table   table-centered table-borderless">
            <thead>
              <tr className="table-warning">
                <th scope="col" style={{ width: '60px' }}>
                  S.No.
                </th>
                <th scope="col">Title/Slug</th>
                <th scope="col">Category</th>
                <th scope="col">Sub Category</th>
                <th scope="col">Language</th>
                <th scope="col">Published Date</th>
                <th scope="col">Active</th>
                <th scope="col">Deleted</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {!isEmpty(faqsList) ? (
                faqsList?.map((elem, index) => (
                  <tr key={`_index_${elem.id}`} className={!elem?.active || elem?.deleted ? 'bg-danger' : ''}>
                    <td>{printSerialNumbers(faqsPagination)[index]}</td>
                    <td>
                      <Link
                        to={buildURL(SMKLinks.EDIT_SCHOOL_FAQ, {
                          schoolId,
                          id: elem?.id,
                        })}>
                        {elem?.title}
                      </Link>
                      <br />
                      {elem?.slug}
                    </td>
                    <td>{elem?.category}</td>
                    <td>{elem?.subCategory}</td>
                    <td>{elem?.language === 'en' ? 'English' : 'Hindi'}</td>
                    <td>{elem?.metadata?.date}</td>
                    <td>
                      <Badge className={elem?.active ? 'bg-success' : 'bg-danger'}>
                        {elem?.active ? 'Active' : 'Disabled'}
                      </Badge>
                    </td>
                    <td>
                      <Badge className={elem?.deleted ? 'bg-success' : 'bg-danger'}>
                        {elem?.deleted ? 'Yes' : 'No'}
                      </Badge>
                    </td>
                    <td className="text-center">
                      <UncontrolledDropdown>
                        <DropdownToggle className="card-drop" tag="a">
                          <i className="mdi mdi-dots-vertical font-size-18" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                          <DropdownItem onClick={() => handleActive(elem)}>
                            <i
                              className={`fas  ${
                                elem?.active ? 'fa-ban text-danger' : 'fa-power-off text-success'
                              }   m-1 pe-3`}
                            />
                            {elem?.active ? 'Disable' : 'Enable'}
                          </DropdownItem>

                          <DropdownItem onClick={() => handleDelete(elem)}>
                            <i className={'fas fa-trash-alt text-danger m-1 pe-3'} />
                            {elem?.deleted ? 'Undelete' : 'Delete'}
                          </DropdownItem>

                          <Link
                            to={buildURL(SMKLinks.EDIT_SCHOOL_FAQ, {
                              schoolId,
                              id: elem.id,
                            })}>
                            <DropdownItem>
                              <i className="fas fa-pencil-alt text-success m-1 pe-3 " />
                              Edit
                            </DropdownItem>
                          </Link>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                ))
              ) : (
                <TableError />
              )}
            </tbody>
          </Table>
        </div>

        {!isEmpty(faqsList) && <Paginate pageInfo={faqsPagination} onChangePage={handleChangePage} />}
      </div>
    </div>
  );
};

export default SchoolFaqs;
